function handleClick(manager, event) {
  const button = event.target?.closest?.("[data-action]");
  if (!button || !manager.contains?.(button)) {
    return;
  }
  const action = button.dataset.action;
  if (action === "open") {
    manager.openManager();
    return;
  }
  if (action === "save-current" || action === "save-current-dialog") {
    if (action === "save-current-dialog" && !manager.model().selectedIsActive) {
      return;
    }
    void manager.saveCurrent();
    return;
  }
  if (action === "discard-current" || action === "discard-current-dialog") {
    if (action === "discard-current-dialog" && !manager.model().selectedIsActive) {
      return;
    }
    void manager.discardCurrent();
    return;
  }
  if (action === "workspace-tab") {
    manager.workspaceView = button.dataset.view === "details" ? "details" : "library";
    manager.renderWorkspaceTabs();
    return;
  }
  if (action === "detail-tab") {
    manager.detailView = button.dataset.view === "history" ? "history" : "changes";
    manager.renderDetailTabs();
    return;
  }
  if (action === "select-preset") {
    manager.selectItem(button.dataset.itemKey);
    return;
  }
  if (action === "activate-preset") {
    void manager.activateItem(button.dataset.itemKey);
    return;
  }
  if (action === "cancel-save-as") {
    manager.saveAsOpen = false;
    manager.renderState();
    return;
  }
  if (action === "save-as") {
    event.preventDefault();
    void manager.saveAs();
    return;
  }
  if (action === "undo" || action === "undo-dialog") {
    if (action === "undo-dialog" && !manager.model().selectedIsActive) {
      return;
    }
    void manager.undoCurrent();
    return;
  }
  if (action === "redo" || action === "redo-dialog") {
    if (action === "redo-dialog" && !manager.model().selectedIsActive) {
      return;
    }
    void manager.redoCurrent();
    return;
  }
  if (action === "use-selected") {
    void manager.useSelected();
    return;
  }
  if (action === "clone-selected") {
    void manager.cloneSelected();
    return;
  }
  if (action === "save-local-to-account") {
    void manager.saveLocalToAccount();
    return;
  }
  if (action === "export-selected") {
    void manager.exportSelected();
    return;
  }
  if (action === "delete-selected") {
    void manager.deleteSelected();
    return;
  }
  if (action === "import") {
    const input = manager.element("file-input");
    if (input) {
      input.value = "";
      input.click?.();
    }
    return;
  }
  if (action === "use-revision") {
    manager.focusHistoryLeft = true;
    void manager.useRevision(button.dataset.revisionId);
  }
}

function handleInput(manager, event) {
  if (event.target === manager.element("preset-search")) {
    manager.libraryQuery = event.target.value;
    manager.renderLibrary(manager.model());
  }
}

function handleChange(manager, event) {
  if (event.target === manager.element("history-alternates-toggle")) {
    manager.showAlternateHistoryBranches = event.target.checked === true;
    manager.focusHistoryLeft = true;
    manager.renderState();
    return;
  }
  if (event.target === manager.element("selected-name")) {
    void manager.renameSelected(event.target);
    return;
  }
  if (event.target === manager.element("file-input")) {
    void manager.importFile(event.target);
  }
}

function handleSubmit(manager, event) {
  if (event.target !== manager.element("save-as-form")) {
    return;
  }
  event.preventDefault();
  void manager.saveAs();
}

function handleKeyDown(manager, event) {
  if (event.target === manager.element("selected-name")) {
    if (event.key === "Enter") {
      event.preventDefault();
      event.target.blur?.();
    } else if (event.key === "Escape") {
      const item = manager.model().selectedItem;
      event.target.value = item?.name || "";
      event.target.blur?.();
    }
    return;
  }
  if (event.target === manager.element("save-as-name") && event.key === "Escape") {
    event.preventDefault();
    manager.saveAsOpen = false;
    manager.renderState();
  }
}

export function createPresetManagerEventHandlers(manager) {
  if (!manager || typeof manager !== "object") {
    throw new TypeError("Preset manager event handlers require a manager.");
  }
  return Object.freeze({
    change: (event) => handleChange(manager, event),
    click: (event) => handleClick(manager, event),
    input: (event) => handleInput(manager, event),
    keydown: (event) => handleKeyDown(manager, event),
    submit: (event) => handleSubmit(manager, event),
  });
}
